// Load comments

function loadComments() {
  $('.show-issue-modal__comments').html(
    '<div class="panel__empty">Loading comments...</div>'
  );

  $.ajax({
    url: '/api/forge/oauth/token',
    success: function (response) {
      var access_token = response.access_token;

      // Save issue
      $.ajax({
        url: settings.apiEndpoint + '/api/issue-comments',
        data: {
          container_id: app.issueContainerId,
          access_token: access_token,
          issue_id: app.showIssueModal.issueId
        },
        method: 'GET',
        success: function (response) {
          addComments(response.results);
        },
        error: function () {
          error();
        }
      });
    },
    error: function () {
      error();
    }
  });
}

// Add comments

function addComments(data) {
  $('.show-issue-modal__comments').html('');
  $.each(data, function (index, item) {
    addComment(item);
  });

  if (!$('.show-issue-modal__comment-wrapper').length) {
    $('.show-issue-modal__comments').html(
      '<div class="panel__empty show-issue-modal__comments-first-notice">' + __('commentsSectionBeTheFirstToWriteAComment') + '</div>'
    );
  }
}

// Add a comment

function addComment(data) {

  $('.show-issue-modal__comments .panel__empty').remove();

  var wrapper = $('<div class="show-issue-modal__comment-wrapper"/>');
  wrapper.prependTo($('.show-issue-modal__comments'));

  wrapper.append(
    $('<div class="show-issue-modal__comment-created"/>').html(
      __('dateCreatedOn') + ' ' + getIssueCreatedDate(data.createdAt, true)
    )
  );

  if (isFeatureEnabled('showUsernames')) {
    wrapper.append(
      $('<div class="show-issue-modal__comment-author"/>').html(
        getUsername(data.createdBy)
      )
    );
  }

  wrapper.append(
    $('<div class="show-issue-modal__comment-comment"/>').html(
      data.body
    )
  );
}

// Save a comment

function saveComment() {
  var comment = $('.show-issue-modal__comments-add input').val();

  // Save comment
  $.ajax({
    url: '/api/forge/oauth/token',
    success: function (response) {
      var access_token = response.access_token;

      // Save issue
      $.ajax({
        url: settings.apiEndpoint + '/api/issue-comment',
        data: {
          container_id: app.issueContainerId,
          access_token: access_token,
          issue_id: app.showIssueModal.issueId,
          data: {
            body: comment
          },
        },
        method: 'POST',
        success: function (response) {
          if (response && response.body) {
            success(__('commentsSaveSuccessNotice'));
            $('.show-issue-modal__comments-add input').val('');
            addComment(response);
          } else {
            error();
          }
        },
        error: function () {
          error();
        }
      });
    },
    error: function () {
      error();
    }
  });
}
